module.exports = "<button-dropdown drop-data=\"[{name:'时间'},{name:'车型'},{name:'电话'}]\" checked-item=\"checkedItem\">{{checkedItem.name}}</button-dropdown>";